// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { Control } from '../elements/Control';
import { KeyCode, KeyEventProcessor } from '@shared/commons/KeyEventProcessor';
import { QuickTableRow } from '../elements/QuickTable/QuickTableRow';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { ThemeManager } from '../misc/ThemeManager';
import { QuickTableCell } from '../elements/QuickTable/QuickTableCell';
import { EventEmitter } from 'events';
import { AutoCompleteTableQuickRactive } from '../elements/QuickTable/AutoCompleteQuickTableRactive';
export class LookUpProps {
}
export class LookUpComponentView {
    constructor() {
        this.haveError = false;
    }
}
export class LookUpViewModel extends AbstractViewModel {
    get haveError() {
        return this.componentView.haveError;
    }
    set haveError(value) {
        this.updateComponentView('haveError', value);
    }
    get btnTooltip() {
        return this.componentView.btnTooltip;
    }
    set btnTooltip(value) {
        this.updateComponentView('btnTooltip', value);
    }
    get currentNameFilter() {
        return this.componentView.currentNameFilter;
    }
    set currentNameFilter(value) {
        this.updateComponentView('currentNameFilter', value);
    }
    get textBoxValue() {
        return this.componentView.textBoxValue;
    }
    set textBoxValue(value) {
        this.updateComponentView('textBoxValue', value);
    }
    constructor(componentView) {
        super(componentView);
        this.needCloseTableAfterClick = true;
        this.AUTOCOMPLETE_MAX_ROWS_COUNT = 10;
        this.eventEmitter = new EventEmitter();
        this._isAutoCompleteTableVisible = false;
        this.onAutoCompleteGlobalKeyDownHandled = this.onAutoCompleteGlobalKeyDownHandled.bind(this);
        this.onAutoCompleteQuickTableCreated = this.onAutoCompleteQuickTableCreated.bind(this);
        this.onAutoCompliteSelectionChanged = this.onAutoCompliteSelectionChanged.bind(this);
        this.dropDownFormCallBack = this.dropDownFormCallBack.bind(this);
        this.onCloseDropDownForm = this.onCloseDropDownForm.bind(this);
        this.onSubscribeDrawAutoCompleteQuickTable = this.onSubscribeDrawAutoCompleteQuickTable.bind(this);
        this.onUnsubscribeDrawAutoCompleteQuickTable = this.onUnsubscribeDrawAutoCompleteQuickTable.bind(this);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    get isAutoCompleteTableVisible() {
        return this._isAutoCompleteTableVisible;
    }
    set isAutoCompleteTableVisible(value) {
        this._isAutoCompleteTableVisible = value;
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        if (isNullOrUndefined(props.selectedItem)) {
            this.onSelectItem(this.props.items[0]);
        }
        else {
            this.updateSelectedItemAndText(props.selectedItem);
        }
    }
    update(props, prevProps) {
        super.update(props, prevProps);
        this.props = props;
        if (props.selectedItem !== prevProps.selectedItem) {
            this.updateSelectedItemAndText(props.selectedItem);
        }
    }
    // public override oncomplete (): void {
    //     super.oncomplete();
    //     // this.on(ControlEvents.LostFocus, this.onLostFocus.bind(this));
    // }
    dispose() {
        this.lookupErrorHideShow(false);
        this.hideAutoCompleteTable();
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    onSubscribeSelectAllInTextBox(callback) {
        this.eventEmitter.on('selectAllInTextBox', callback);
    }
    onUnsubscribeSelectAllInTextBox(callback) {
        this.eventEmitter.off('selectAllInTextBox', callback);
    }
    onSubscribeDrawAutoCompleteQuickTable(callback) {
        this.eventEmitter.on('drawAutoCompleteQuickTable', callback);
    }
    onUnsubscribeDrawAutoCompleteQuickTable(callback) {
        this.eventEmitter.off('drawAutoCompleteQuickTable', callback);
    }
    localize() {
        this.btnTooltip = this.getButtonTooltip();
    }
    onBtnClick() {
        return false;
    }
    onTextChange(value) {
        this.textBoxValue = value;
        this.currentNameFilter = value.toLowerCase();
        this.populateAutoCompliteAsync();
    }
    populateAutoCompliteAsync() {
        clearTimeout(this.asyncPopulateInterval);
        this.asyncPopulateInterval = null;
        this.asyncPopulateInterval = setTimeout(this.populateAutoComplite.bind(this), 300);
    }
    populateAutoComplite() {
        const qTable = this.autoCompliteQuickTable;
        qTable.ClearRows();
        if (isValidString(this.currentNameFilter)) {
            this.fillAutoCompliteTableByItems();
        }
        else {
            this.lookupErrorHideShow(false);
            return;
        }
        const rowsCount = qTable.visibleRowCount(); // rowsArray.length;
        if (rowsCount > 0) {
            this.lookupErrorHideShow(false);
        }
        else {
            this.lookupErrorHideShow(true);
        }
    }
    fillAutoCompliteTableByItems() {
        const qTable = this.autoCompliteQuickTable;
        let findStr = '';
        if (!isNullOrUndefined(this.currentNameFilter)) {
            findStr = this.currentNameFilter.toLowerCase();
        }
        const items = this.props.items;
        const len = items.length;
        for (let j = 0; j < len; j++) {
            const curItem = items[j];
            const curItemStr = curItem.toString(true);
            if (!isNullOrUndefined(this.currentNameFilter)) {
                const curItemFindStr = curItemStr.toLowerCase();
                if (curItemFindStr.indexOf(findStr) === -1) {
                    continue;
                }
            }
            const r = new QuickTableRow();
            r.id = j;
            const cell = new QuickTableCell();
            cell.value = curItem;
            cell.formattedValue = curItemStr;
            cell.textPattern = this.currentNameFilter;
            r.cells.push(cell);
            qTable.AddRow(r);
        }
    }
    onAutoCompliteSelectionChanged(fromMouseClick) {
        if (fromMouseClick) {
            this.onAutoCompliteSelectRow(this.autoCompliteQuickTable);
        }
    }
    onAutoCompliteSelectRow(qTable) {
        const selectRowId = qTable.selectedRowIds[0];
        const defaultRow = qTable.rowsArray[0];
        if (isNullOrUndefined(selectRowId)) {
            this.onSelectItem(this.getTypingLookupValueForSet(this.textBoxValue, defaultRow));
        }
        else {
            const selectRow = qTable.rows[selectRowId];
            if (isNullOrUndefined(selectRow)) {
                this.onSelectItem(this.getTypingLookupValueForSet(this.textBoxValue, defaultRow));
            }
            else {
                this.onSelectItem(selectRow.cells[0].value);
            }
        }
        if (this.needCloseTableAfterClick) {
            this.hideAutoCompleteTable();
            // void qTable.set({ visible: false });
            qTable.selectedRowIds = [];
            delete qTable.lastSelectedRowId;
        }
    }
    onLostFocus() {
        clearTimeout(this.asyncPopulateInterval);
        this.asyncPopulateInterval = null;
        // this.autoCompliteQuickTable.set({ visible: false });
        // this.autoCompliteQuickTable.lostFocus();
        this.lookupErrorHideShow(false);
    }
    onKeyDown(event) {
        if (!this.props.enabled /* || !this.get('focused') */) {
            return true;
        }
        if (this.isAutoCompleteTableVisible) {
            event.stopPropagation();
        }
        this.lastKeyCode = event.keyCode;
        const keyCode = event.keyCode;
        if (keyCode !== KeyCode.UP &&
            keyCode !== KeyCode.DOWN &&
            keyCode !== KeyCode.ENTER &&
            keyCode !== KeyCode.ESC) {
            return true;
        }
        const autoCompliteQuickTable = this.autoCompliteQuickTable;
        if (this.isAutoCompleteTableVisible) {
            // HACK.
            if (keyCode === KeyCode.ENTER) {
                this.onAutoCompliteSelectRow(autoCompliteQuickTable);
                this.onSelectAllInTextBox();
            }
            else if (keyCode === KeyCode.ESC) {
                this.onLostFocus();
            }
            else {
                autoCompliteQuickTable.trySelectUpDown(keyCode, false);
            }
        }
        else if (keyCode === KeyCode.ESC) {
            return;
        }
        else if (keyCode !== KeyCode.ENTER) {
            this.moveToItem(keyCode === KeyCode.DOWN);
        }
        else if (keyCode === KeyCode.ENTER) {
            this.onAutoCompliteSelectRow(autoCompliteQuickTable);
            this.onSelectAllInTextBox();
        }
        this.lastKeyCode = -1;
        return false;
    }
    // If lookup's table is focused;
    onAutoCompleteGlobalKeyDownHandled() {
        if (KeyEventProcessor.currentButton === KeyCode.ENTER) {
            this.onAutoCompliteSelectRow(this.autoCompliteQuickTable);
        }
    }
    onMouseWheel(event) {
        if (!this.props.enabled /* || !this.get('focused') */ || this.isAutoCompleteTableVisible) {
            return true;
        }
        this.moveToItem(event.deltaY < 0);
        return false;
    }
    moveToItem(next) {
        const newIndex = this.selectedItemIndex + (next ? 1 : -1);
        if (newIndex >= 0 && newIndex < this.props.items.length) {
            if (this.isNeedSkeepItem(this.props.items[newIndex])) {
                return;
            }
            this.selectedItemIndex = newIndex;
            this.onSelectItem(this.props.items[newIndex]);
            this.onSelectAllInTextBox();
        }
    }
    onAutoCompleteQuickTableCreated(quickTable) {
        this.autoCompliteQuickTable = quickTable;
        this.autoCompliteQuickTableThemeChange(quickTable);
        Control.Ticker.Subscribe(this.tick, this);
    }
    tick() {
        this.drawAutoCompleteQuickTable();
    }
    autoCompliteQuickTableThemeChange(quickTable) {
        quickTable.themeChange();
        quickTable.selectedBackColor = ThemeManager.colors.autocompleteQuickTreeNodeBackgroundSelected;
        quickTable.selectedHoveredBackColor = ThemeManager.colors.selectedAndHoveredRowBackColor;
        quickTable.hoveredBackColor = ThemeManager.colors.quickTreeNodeBackgroundHovered;
        quickTable.selectedForeColor = ThemeManager.colors.quickTreeNodeForegroundSelected;
    }
    showDropDowmForm(mainContainerRef) { }
    showAutoCompleteQuickTable(mainContainerRef) {
        const lookupSearchProps = this.getAutoCompleteQuickTableProps(mainContainerRef);
        AutoCompleteTableQuickRactive.show(lookupSearchProps);
    }
    hideAutoCompleteTable() {
        this.isAutoCompleteTableVisible = false;
        Control.Ticker.UnSubscribe(this.tick, this);
        AutoCompleteTableQuickRactive.hide();
    }
    lookupErrorHideShow(isShow) {
        if (isShow) {
            this.haveError = true;
        }
        else {
            this.haveError = false;
        }
    }
    showPopupError(errorTextForNumeric, headerText) {
        if (!this.props.enabled /* || !this.get('focused') */ || !isValidString(errorTextForNumeric)) {
            // return
        }
    }
    getButtonTooltip() {
        return '';
    }
    getTypingLookupValueForSet(textValueIndificator, defaultRow) {
        return null;
    }
    dropDownFormCallBack(result) {
        this.onSelectItem(result);
    }
    onCloseDropDownForm() { }
    onSelectItem(item) {
        if (item === this.props.selectedItem) {
            this.textBoxValue = item;
        }
        this.props.onSelectItem(item);
    }
    onSelectAllInTextBox() {
        this.eventEmitter.emit('selectAllInTextBox');
    }
    drawAutoCompleteQuickTable() {
        this.eventEmitter.emit('drawAutoCompleteQuickTable');
    }
    isNeedSkeepItem(item) {
        return false;
    }
    getAutoCompleteQuickTableProps(mainContainer) {
        const pos = mainContainer.getBoundingClientRect();
        const autoCompleteProps = {
            maxElementsCount: this.AUTOCOMPLETE_MAX_ROWS_COUNT,
            x: pos.left,
            y: pos.top + mainContainer.offsetHeight,
            width: 400,
            enabled: false,
            additionalClass: 'quickTableOuter-position-absolute',
            quickTableReactActions: {
                onKeyDown: () => {
                    this.onAutoCompleteGlobalKeyDownHandled();
                },
                onQuickTableCreated: (quickTable) => {
                    this.onAutoCompleteQuickTableCreated(quickTable);
                },
                subscribeOnDrawQuickTable: (callback) => {
                    this.onSubscribeDrawAutoCompleteQuickTable(callback);
                },
                unsubscribeOnDrawQuickTable: (callback) => {
                    this.onUnsubscribeDrawAutoCompleteQuickTable(callback);
                }
            },
            autoCompleteQuicktableEvents: {
                onAutoCompliteSelectionChanged: (fromMouseClick) => {
                    this.onAutoCompliteSelectionChanged(fromMouseClick);
                },
                onElementsCountChanged: (elementsCount) => {
                    this.isAutoCompleteTableVisible = elementsCount > 0;
                }
            }
        };
        return autoCompleteProps;
    }
    getDropDownFormProps(mainContainerRef, props) {
        if (isNullOrUndefined(props)) {
            return null;
        }
        const lookupRect = mainContainerRef.getBoundingClientRect();
        props.x = lookupRect.left;
        props.y = lookupRect.top;
        props.onSelect = this.dropDownFormCallBack;
        // props.onClose = this.onCloseDropDownForm;
        props.isMultiSelectMode = this.props.isMultiSelect;
        props.isMultiSelectCheckboxUsing = this.props.isMultiSelectMode;
        props.isShowSelectAll = this.props.isMultiSelect;
        props.items = this.props.items;
        props.autoClose = true;
        return props;
    }
    updateSelectedItemAndText(newSelectedItem) {
        this.textBoxValue = newSelectedItem.toString(true);
        this.updateSelectedItemIndex(newSelectedItem);
    }
    updateSelectedItemIndex(newSelectedItem) {
        if (newSelectedItem === this.props.items[this.selectedItemIndex]) {
            return;
        }
        const index = this.props.items.indexOf(newSelectedItem);
        if (index !== -1) {
            this.selectedItemIndex = index;
        }
    }
}
